import React from 'react'
import { useSelector } from 'react-redux'
import { IPendencies } from 'src/models/pendencies'
import { IState } from 'src/models/state'

export const PendingSidebar = () => {

	const pendencies = useSelector<IState, IPendencies>(state => state.pendencies)
	
	return (
		<div className='sideWallets'>
			<div className='boxTitle'><span>Pending Status</span></div>
			<div className='tableHeader'>
				<span className='asset'>Service</span>
				<span className='amount'>Amount</span>
			</div>
			<div className='tableRow'>
				<span className='asset'>KYC</span>
				<span className='amount'>{pendencies.kycs}</span>
			</div>
			<div className='tableRow'>
				<span className='asset'>Deposits</span>
				<span className='amount'>{pendencies.deposits}</span>
			</div>
			<div className='tableRow'>
				<span className='asset'>Withdrawals</span>
				<span className='amount'>{pendencies.withdrawals}</span>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/pendingSidebar.tsx